import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import { endReplay } from "../../src/shell/endReplay";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { customer } from "../characters/Customer";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doImageShake, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8VanessaMCPark_1 } from "./V8_VanessaMCPark";
import { V9VanessaMCBusNight_2_CustomerStory_After } from "./V9_VanessaMCBusNight";

const v8 = images.v8;
export const V8VanessaCustomerHotel = async (): Promise<any> => {
    //no image here so it will use the previous image(currently the park talking V8VanessaMCPark_9);
    if (Question.globalAnswers.v7VanessaGiveCustomerWhatHeWants || Question.globalAnswers.v8FuckedAngela === false) {

        vanessa.talk(`So here I was minding my own business when I got a text...`);
        vanessa.talk(`It said, meet me at the attached address.`);
        vanessa.talk(`It was obviously him and I knew the place so I had no problem going there and getting this over with...`);
        vanessa.talk(`I reached the address, it was the The Aurum Elysium hotel.`);

        vanessa.think(`I entered the hotel and went to the top floor to room 420 as it was written in the text.`);
        vanessa.think(`I opened the door and stepped inside...`);
    }
    doTransition(v8.V8VanessaCustomerHotel_2, { duration: 2, wait: 2 });
    vanessa.think(`Someone finally got some balls. He is completely naked...`);
    vanessa.think(`Or maybe only shirtless... I can't really see from here.`);

    customer.talk(`I've been expecting you.`);
    vanessa.talk(`Duh... You invited me here.`);
    vanessa.talk(`I gotta say! This room is actually nice!`);
    vanessa.talk(`I was sure you were going to invite me to some creepy-ass cheap hotel.`);
    customer.talk(`SILENCE!`);
    customer.talk(`Step into the bathroom on your right and change to some decent clothes.`);

    if (Question.globalAnswers.v8FuckedAngela) {
        return jump(V8VanessaCustomerHotel_ConfrontingHim, "V8VanessaCustomerHotel_ConfrontingHim");
    }

    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_3);
    vanessa.think(`He didn't even turn around to see what I was wearing but whatever.`);
    vanessa.think(`I'll play his little game...`);

    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_4);
    vanessa.think(`Oh, wow. That's a fine-ass dress!`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_5);
    vanessa.think(`And heels on top of it? SWEET!`);
    vanessa.think(`I hope I get to keep it like the previous dress.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_6);
    vanessa.think(`And of course... The makeup.`);
    vanessa.think(`Well, whatever.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_8);
    vanessa.think(`I'll just have to play along and by the time I'm out of here I'll have my job back!`);
    doTransition(images.v8.V8VanessaCustomerHotel_9);
    vanessa.think(`Fuck I'm hot!`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_10);
    vanessa.think(`You can say many things about that creep, but he definitely knows which dress will show my curves the best.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_6);
    vanessa.think(`Alright, let's put on some makeup...`);
    vanessa.think(`Whatever gets him off.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_11);
    vanessa.think(`Yup... That's what he likes...`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_12);

    customer.talk(`Fix your hair before you appear in front of me.`, { method: "Shouting" });
    customer.talk(`I don't want to see that ponytail again.`, { method: "Shouting" });

    vanessa.think(`What's wrong with my ponytail?!`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_14);
    vanessa.think(`Whatever...`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_15);
    vanessa.think(`I prefer my ponytail but as I said... Whatever gets him off.`);
    vanessa.think(`Alright Vanessa! Go get that job!`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_16);
    vanessa.talk(`I'm ready darling!`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_17);
    vanessa.talk(`Missed me?`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_18);
    vanessa.think(`Oh wow, he is naked! Someone got some courage finally!`);
    vanessa.think(`That's great! It means he's going all out!`);
    vanessa.think(`Just a quick handjob and I'm outta here.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_17);
    customer.talk(`First of all stand straight when you talk to me.`);
    vanessa.think(`Pft... Whatever I'll let him get his win.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_19);
    customer.talk(`Second, fix you hair. Bring it to the front.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_20, { wait: 1.2 });
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_21);
    customer.talk(`Excellent.`);
    customer.talk(`But there is still one thing missing.`);

    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_22);
    customer.talk(`On the cabinet, there is a necklace. Go over there and put it on.`);
    vanessa.think(`Nice! I hope I get to keep it!`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_23);
    vanessa.think(`Oh. I see.`);
    vanessa.think(`Our little grandpa is a control freak.`);
    vanessa.think(`Last time he stormed out when I started to take control.`);
    vanessa.think(`I'll have to keep reminding myself that he is the boss right now.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_24);
    vanessa.think(`Alright Vanessa, keep playing your part. Do as he says and you should be good.`);
    vanessa.think(`I can't lie to myself... It's a bit exciting to see how far he's going to take this.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_25.partials.V8VanessaCustomerHotel_25_p, { putParent: true });
    vanessa.talk(`I gotta admit... That's a really nice necklace!`);
    vanessa.talk(`Can I keep it?`);

    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_25);
    customer.talk(`How dare you to look down on me?`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_26.partials.V8VanessaCustomerHotel_26_p, { putParent: true });
    vanessa.talk(`So, can I keep it?`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_26);
    customer.talk(`Of course!`);
    customer.talk(`Anything else?`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_26.partials.V8VanessaCustomerHotel_26_p);
    vanessa.talk(`Well... There is that little thing with my job...`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_26);
    customer.talk(`That's why we are here no?`);
    customer.talk(`We'll get to that in a minute.`);
    customer.talk(`Anything else you have in mind?`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_26.partials.V8VanessaCustomerHotel_26_p);
    vanessa.talk(`Nah... That pretty much covers everything.`);

    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_26);
    customer.talk(`Fine.`);
    customer.talk(`Now, before we start...`);
    customer.talk(`Let me make some things clear.`);
    customer.talk(`You are here by your own free will.`);
    customer.talk(`You can leave whenever you want.`);
    customer.talk(`But as long as you are here...`);
    doImageShake(images.v8.V8VanessaCustomerHotel_27);
    customer.talk(`You are going to treat me with RESPECT!`);
    customer.talk(`You are going to OBEY!`);
    customer.talk(`You are going to SERVE!`);
    customer.talk(`And you won't speak unless spoken to!`);
    customer.talk(`Am I clear?`);
    vanessa.think(`Wow.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_27.partials.V8VanessaCustomerHotel_28);
    vanessa.talk(`Yes.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_27);
    customer.talk(`Yes what?`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_27.partials.V8VanessaCustomerHotel_28);
    customer.talk(`Yes sir.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_27);
    customer.talk(`I'm not your SIR.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_27.partials.V8VanessaCustomerHotel_28);
    vanessa.talk(`Yes, Master.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_27);
    customer.talk(`Go get me a glass of whiskey.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_27.partials.V8VanessaCustomerHotel_28);
    vanessa.talk(`Yes, Master.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_29);
    vanessa.think(`Wow... Grandpa is so kinky.`);
    vanessa.think(`He's really enjoying his power trip.`);
    vanessa.think(`Not that I mind.`);
    vanessa.think(`I like guys that know how to take control and be dominant.`);
    vanessa.think(`I just have to do as he says and I should be good.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_30);
    vanessa.talk(`Here is your drink Master.`);

    customer.talk(`Do you really expect me to drink it by myself?`);
    vanessa.talk(`...`);
    return jump(V8VanessaCustomerHotel_2, "V8VanessaCustomerHotel_2");
};
export const V8VanessaCustomerHotel_2 = async (): Promise<any> => {
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_31);
    customer.talk(`Sit on my lap.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_32);
    customer.talk(`Good girl.`);
    customer.talk(`Now let me tell you a story.`);

    customer.talk(`You know, I've known many girls like you over the years.`);
    customer.talk(`You think you own the world.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_33);
    customer.talk(`You go around and boss everyone around and think you can get anything because of your good looks.`);
    customer.talk(`But deep inside you are shallow.`);
    customer.talk(`You have nothing to offer besides your appearance.`);

    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_32);
    customer.talk(`You think that with one little cute smile you can get it all.`);
    customer.talk(`And sometimes that may be true.`);
    customer.talk(`Everything is so easy for you.`);
    customer.talk(`You don't have to work hard. You don't need to study.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_34);
    customer.talk(`You can just flash your tits and everything is served to you on a silver plate.`);

    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_33);
    customer.talk(`But every once in a while you'll come across someone that will see through you.`);
    customer.talk(`He'll make you understand you are nothing.`);
    customer.talk(`I've known girls like you my whole life, Vanessa.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_32);
    customer.talk(`I remember one girl in particular. She was just like you.`);
    customer.talk(`She thought she was invincible because of her beauty.`);
    customer.talk(`But I showed her that she was wrong.`);

    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_33);

    customer.talk(`You are lying to yourself if you thought that you came here to get your job back.`);
    customer.talk(`You can get a different, better job easily.`);

    customer.talk(`But you are here because you want someone to put you in your place.`);
    customer.talk(`For the first time someone told you NO.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_32);
    customer.talk(`And it turns you on.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_34);
    customer.talk(`SIP!`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_35);
    vanessa.think(`I didn't come here for bedtime stories...`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_36);
    vanessa.think(`I hope he didn't plan to bore me to death.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_32);
    customer.talk(`That's enough.`);
    customer.talk(`Get off me and remove your dress.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_37);
    customer.talk(`SLOWLY!`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_38, { wait: true });
    doWaitImageByTime(images.v8.V8VanessaCustomerHotel_39);
    customer.talk(`You are lucky I gave you endless chances to get on my good side.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_40);
    customer.talk(`Not many slaves have the chance to be as lucky as you are right now.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_41);
    customer.talk(`Don't you agree?`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_42);
    vanessa.talk(`Yes Master.`);
    vanessa.think(`He got a boner just by hearing himself talk.`);
    doImageShake(images.v8.V8VanessaCustomerHotel_43);
    customer.talk(`Now it's time for you to show me how much you appreciate it.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_44);
    customer.talk(`You better put your soul into it.`);
    ImageClass.setAnimation(images.v8.Anim_V8VanessaCustomerBJ, { hideText: true, wait: true });
    customer.talk(`Ahh!!!`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_66, { wait: true });


    return jump(V8VanessaCustomerHotel_3, "V8VanessaCustomerHotel_3");

};

export const V8VanessaCustomerHotel_3 = async (): Promise<any> => {
    doWaitImageByTime(v8.V8VanessaCustomerHotel_45.partials.V8VanessaCustomerHotel_45_p, { putParent: true });
    customer.talk(`What do we say?`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_45);
    vanessa.talk(`Thank you Master.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_45.partials.V8VanessaCustomerHotel_45_p);
    customer.talk(`You're welcome.`);
    customer.talk(`Now, go get me another drink.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_47);
    customer.talk(`And don't you dare to wipe off your face.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_46);
    vanessa.think(`How much does this fucking guy drink?`);
    vanessa.think(`He should have passed out by now.`);
    vanessa.think(`But I believe this is it! Surely I got my job back now!`);
    vanessa.think(`I'll just have to give him this last drink and that's settles it.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_49);
    vanessa.talk(`Here is your drink Master.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_47);
    customer.talk(`I must say, you did an excellent job today.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_47.partials.V8VanessaCustomerHotel_47_p);
    vanessa.talk(`Thank you, Master.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotel_47);
    customer.talk(`Now, suck my balls.`);
    vanessa.think(`Oh wow, that's a little straight forward...`);
    vanessa.think(`But I have no choice, I've gone this far.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_51);
    customer.talk(`Don't stop unless I tell you to.`);
    // TODO: animate balls licking.
    vanessa.think(`I kept licking the old's man balls while he drank his whiskey...`);
    vanessa.think(`If you ask me if I had any regrets? No.`);

    doWaitImageByTime(v8.V8VanessaCustomerHotel_50);
    vanessa.think(`But I was wondering how long he was gonna keep this act up.`);
    vanessa.think(`I knew that if I left all of that was for nothing.`);


    doWaitImageByTime(v8.V8VanessaCustomerHotel_51);
    customer.talk(`It's been a long day, I need some rest.`);
    customer.talk(`Go over to the balcony and squeeze your breasts against the window.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_52);
    vanessa.think(`I've seen and done some weird stuff...`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_53);
    vanessa.think(`But it's the first time someone asked me to do this.`);
    customer.talk(`GET OVER HERE!`, { method: "Shouting" });
    doWaitImageByTime(v8.V8VanessaCustomerHotel_54);
    vanessa.talk(`Yes, Master?`);
    customer.talk(`Block the sun for me so I can get some sleep.`);
    customer.talk(`You can leave once I fall asleep.`);
    doTransition(v8.V8VanessaCustomerHotel_55);
    customer.talk(`*Snoring*`);
    vanessa.think(`He is sleeping, I can leave now.`);
    await endReplay(replayScenesList.v8VanessaCustomerHotel);

    return jump(V8VanessaCustomerHotel_Bathroom, "V8VanessaCustomerHotel_Bathroom");
};
export const V8VanessaCustomerHotel_Bathroom = async (): Promise<any> => {
    doWaitImageByTime(v8.V8VanessaCustomerHotel_56);
    vanessa.think(`I can't believe he doesn't like my ponytail!`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_57);
    vanessa.think(`There!`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_58);
    vanessa.think(`Much better!`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_59);
    vanessa.talk(`Now let me wipe off this disgusting makeup!`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_60, { wait: true });
    doWaitImageByTime(v8.V8VanessaCustomerHotel_61, { wait: true });
    doWaitImageByTime(v8.V8VanessaCustomerHotel_62);
    vanessa.think(`All gone!`);
    doTransition(v8.V8VanessaCustomerHotel_64);
    vanessa.think(`Like I was never here.`);
    doWaitImageByTime(v8.V8VanessaCustomerHotel_65);
    vanessa.talk(`I can't believe I finally got my job back!`);
    vanessa.talk(`${mc.name} is going to be so proud once he hears it!`);
    if (Game.seenScenarios.includes(`V9VanessaMCBusNight`)) {
        return jump(V9VanessaMCBusNight_2_CustomerStory_After, "V9VanessaMCBusNight_2_CustomerStory_After");

    }

    return jump(V8VanessaMCPark_1, "V8VanessaMCPark_1");
};

export const V8VanessaCustomerHotel_ConfrontingHim = async (): Promise<any> => {
    // TODO: test this
    vanessa.think(`I don't think so!`);
    doWaitImageByTime(v8.V8VanessaCustomerHotelAngela_1);
    vanessa.talk(`Hello dear.`);
    customer.talk(`What do you think you are doing?! I told you to get dressed!`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_2);
    vanessa.talk(`Seeing your attire I'm surprise you care so much about me being dressed.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_3);
    customer.talk(`You are one word away from not getting your job ever again!`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_4);
    vanessa.talk(`Shh!`);
    customer.talk(`Excuse me?!`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_3);
    vanessa.talk(`Trust me, you'd want to hear what I have to say.`);
    customer.talk(`It better be important otherwise your job is screwed!`);
    vanessa.talk(`I heard you the first time.`);
    vanessa.talk(`Where is your phone?`);
    customer.talk(`Why do you need my p--`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_4);
    vanessa.talk(`Shh!!!`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_2);
    customer.talk(`You little brat!`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_3);
    vanessa.talk(`Where is it?`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_5);
    customer.talk(`On the table over there.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_6);
    vanessa.think(`Everything is going according to plan!`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_7);
    vanessa.talk(`There you go.`);
    customer.talk(`Why are you giving me my OWN phone?`);
    vanessa.talk(`You are about to get a text.`);
    // TODO: add buzz sound
    empty.think("Buzz... Buzz...");
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_8);
    customer.talk(`Huh? What is th--`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_9);
    customer.talk(`Is that ANGELA?!`);
    customer.talk(`WHAT DID YOU DO???`);
    doImageShake(images.v8.V8VanessaCustomerHotelAngela_10);
    vanessa.talk(`Hey! Watch your distance!`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_11);
    vanessa.talk(`Now that I have your attention.`);
    vanessa.talk(`Let's start by you sitting down like the little boy you are.`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotelAngela_12);
    vanessa.talk(`Now...`);
    vanessa.talk(`Do I really need to state the obvious?`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_13);
    customer.talk(`No.`);
    customer.talk(`I'll make sure you get your job back.`);
    customer.talk(`But you have to promise this picture never sees the light of day.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_12);
    vanessa.talk(`I have no issue with your grand-daughter.`);
    ImageClass.setImage(images.v8.V8VanessaCustomerHotelAngela_13);
    customer.talk(`Fine...`);
    doWaitImageByTime(images.v8.V8VanessaCustomerHotelAngela_14);
    vanessa.think(`I love coming out on top.`);


    return jump(V9VanessaMCBusNight_2_CustomerStory_After, "V9VanessaMCBusNight_2_CustomerStory_After");
};

